import React from 'react';
import { FormattedMessage } from 'react-intl-next';
import Avatar from '@atlaskit/avatar';
import AvatarGroup from '@atlaskit/avatar-group';
import Button from '@atlaskit/button';
import { Box, xcss } from '@atlaskit/primitives';
import messages from '../../messages';
import { ManagerName, ManagerSection, OffsetWrapper, ReportingLinesSection } from '../../styled/ReportingLines';
import { reportingLinesClicked } from '../../util/analytics';
function getProfileHref(userId, profileUrl) {
  return profileUrl ? profileUrl + userId : undefined;
}
var reportingLinesHeadingDefaultStyles = xcss({
  color: 'color.text',
  font: 'font.heading.xxsmall',
  fontWeight: 'font.weight.semibold',
  marginBottom: 'space.100'
});
var reportingLinesHeadingStyles = xcss({
  marginBottom: '0'
});
var ReportingLinesDetails = function ReportingLinesDetails(props) {
  var _manager$pii, _manager$pii2;
  var fireAnalyticsWithDuration = props.fireAnalyticsWithDuration,
    _props$reportingLines = props.reportingLines,
    reportingLines = _props$reportingLines === void 0 ? {} : _props$reportingLines,
    reportingLinesProfileUrl = props.reportingLinesProfileUrl,
    onReportingLinesClick = props.onReportingLinesClick;
  var _reportingLines$manag = reportingLines.managers,
    managers = _reportingLines$manag === void 0 ? [] : _reportingLines$manag,
    _reportingLines$repor = reportingLines.reports,
    reports = _reportingLines$repor === void 0 ? [] : _reportingLines$repor;
  var manager = managers.length >= 1 ? managers[0] : undefined;
  var hasReports = reports.length > 0;
  var getReportingLinesOnClick = function getReportingLinesOnClick(user, userType) {
    return onReportingLinesClick ? function () {
      fireAnalyticsWithDuration(function (duration) {
        return reportingLinesClicked({
          duration: duration,
          userType: userType
        });
      });
      onReportingLinesClick(user);
    } : undefined;
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, manager && /*#__PURE__*/React.createElement(ReportingLinesSection, null, /*#__PURE__*/React.createElement(Box, {
    xcss: [reportingLinesHeadingDefaultStyles, reportingLinesHeadingStyles]
  }, /*#__PURE__*/React.createElement(FormattedMessage, messages.managerSectionHeading)), /*#__PURE__*/React.createElement(OffsetWrapper, null, /*#__PURE__*/React.createElement(Button, {
    appearance: "subtle",
    spacing: "none",
    href: getProfileHref(manager.accountIdentifier, reportingLinesProfileUrl),
    onClick: getReportingLinesOnClick(manager, 'manager'),
    isDisabled: !onReportingLinesClick
  }, /*#__PURE__*/React.createElement(ManagerSection, null, /*#__PURE__*/React.createElement(Avatar, {
    size: "xsmall",
    src: (_manager$pii = manager.pii) === null || _manager$pii === void 0 ? void 0 : _manager$pii.picture
  }), /*#__PURE__*/React.createElement(ManagerName, null, (_manager$pii2 = manager.pii) === null || _manager$pii2 === void 0 ? void 0 : _manager$pii2.name))))), hasReports && /*#__PURE__*/React.createElement(ReportingLinesSection, null, /*#__PURE__*/React.createElement(Box, {
    xcss: reportingLinesHeadingDefaultStyles
  }, /*#__PURE__*/React.createElement(FormattedMessage, messages.directReportsSectionHeading)), /*#__PURE__*/React.createElement(AvatarGroup, {
    appearance: "stack",
    size: "small",
    data: reports.map(function (member) {
      var _member$pii, _member$pii2;
      return {
        key: member.accountIdentifier,
        name: ((_member$pii = member.pii) === null || _member$pii === void 0 ? void 0 : _member$pii.name) || '',
        src: (_member$pii2 = member.pii) === null || _member$pii2 === void 0 ? void 0 : _member$pii2.picture,
        href: getProfileHref(member.accountIdentifier, reportingLinesProfileUrl),
        onClick: getReportingLinesOnClick(member, 'direct-report')
      };
    }),
    maxCount: 5,
    testId: "profilecard-reports-avatar-group"
  })));
};
export default ReportingLinesDetails;